module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Dodaj menadžera")]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ime")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Prezime")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surname),
      expression: "surname"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Korisničko ime")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lozinka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": "Dodaj",
      "name": "azuriraj",
      "value": "Dodaj"
    },
    on: {
      "click": function($event) {
        return _vm.addCompany()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44053b80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddCompanyStuffModal.vue
// module id = 473
// module chunks = 1